import { withStyles, IconButton } from "@material-ui/core";
import { Close, InfoOutlined } from "@material-ui/icons";
import React from "react";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    position: "absolute",
    zIndex: 4,
    background: theme.ModalBGColor,
    boxShadow: `0px 1px 1px ${theme.AppBGColor}`,
  },
  text: {
    display: "flex",
    fontSize: 10,
    lineHeight: "14px",
    letterSpacing: 0.4,
    color: theme.gridTextColor,
  },
  closeIcon: {
    padding: 4,
    color: theme.iconColor,
  },
  infoIcon: {
    padding: "0 12px",
    fontSize: "1.5rem",
    color: theme.gridTextColor,
  },
});

const ResequenceHelperText = ({ close, classes }) => {
  return (
    <div>
      <div className={classes.container}>
        <p className={classes.text}>
          <InfoOutlined className={classes.infoIcon} />
          <div>
            Move cards up and down to resequence stops and lock positions to
            avoid resequencing when a new stop is added to this route.
          </div>
        </p>
        <IconButton onClick={close} className={classes.closeIcon}>
          <Close />
        </IconButton>
      </div>
    </div>
  );
};

export default withStyles(styles)(ResequenceHelperText);
